/**
 * @description SEO相关的多语言翻译
 */
export const seoTranslations = {
  en: {
    default: {
      title: "Random Pokémon Generator | Free Pokémon Randomizer Tool",
      description: "Generate random Pokémon from any region! Try our Pokémon randomizer and picker tool—fast, fun, and perfect for your next game or challenge."
    },
    whichPokemonAmI: {
      title: "Which Pokémon Am I? | Fun Pokémon Quiz by Random Pokémon Generator",
      description: "Discover which Pokémon you embody with our entertaining quiz! Answer a few simple questions and unveil your Pokémon counterpart. Powered by the Random Pokémon Generator."
    },
    pokemonRandomizer: {
      title: "Advanced Pokémon Randomizer | Ultimate Custom Pokémon Generator",
      description: "Unleash creativity with our Advanced Pokémon Randomizer. Customize generations, types, and more to generate unique Pokémon for challenges, Nuzlockes, or pure fun!"
    },
    aboutUs: {
      title: "About Us | The Team Behind Random Pokémon Generator",
      description: "Meet the creators of the Random Pokémon Generator. Learn about our passion for Pokémon and our mission to provide the best free Pokémon tools for fans worldwide."
    },
    contactUs: {
      title: "Contact Us | Random Pokémon Generator Support & Feedback",
      description: "Get in touch with the Random Pokémon Generator team. We welcome your questions, feedback, and suggestions to make our Pokémon tools even better."
    },
    privacyPolicy: {
      title: "Privacy Policy | Random Pokémon Generator & Tools",
      description: "Review the Privacy Policy for the Random Pokémon Generator and its associated tools. Understand how we protect your data and ensure a safe experience."
    }
  },
  "zh-CN": {
    default: {
      title: "随机宝可梦生成器 | 免费宝可梦随机选择工具",
      description: "从任意地区生成随机宝可梦！尝试我们的宝可梦随机生成工具——快速、有趣，完美适配您的下一场对战或挑战。"
    },
    whichPokemonAmI: {
      title: "我是哪只宝可梦？| 有趣的宝可梦小测试 - 随机宝可梦生成器提供",
      description: "通过我们有趣的测试，发现你代表哪只宝可梦！回答几个简单问题，揭晓你的宝可梦分身。由随机宝可梦生成器强力驱动。"
    },
    pokemonRandomizer: {
      title: "高级宝可梦随机化工具 | 终极自定义宝可梦生成器",
      description: "使用我们的高级宝可梦随机化工具释放创造力。自定义世代、属性等，为挑战、Nuzlocke或纯粹娱乐生成独特的宝可梦！"
    },
    aboutUs: {
      title: "关于我们 | 随机宝可梦生成器背后的团队",
      description: "认识随机宝可梦生成器的创作者。了解我们对宝可梦的热情以及我们为全球粉丝提供最好的免费宝可梦工具的使命。"
    },
    contactUs: {
      title: "联系我们 | 随机宝可梦生成器支持与反馈",
      description: "与随机宝可梦生成器团队取得联系。我们欢迎您提出问题、反馈和建议，以使我们的宝可梦工具更加完善。"
    },
    privacyPolicy: {
      title: "隐私政策 | 随机宝可梦生成器与工具",
      description: "查阅随机宝可梦生成器及其相关工具的隐私政策。了解我们如何保护您的数据并确保安全的体验。"
    }
  },
  "zh-TW": {
    default: {
      title: "隨機寶可夢生成器 | 免費寶可夢隨機選擇工具",
      description: "從任意地區生成隨機寶可夢！嘗試我們的寶可夢隨機生成工具——快速、有趣，完美適配您的下一場對戰或挑戰。"
    },
    whichPokemonAmI: {
      title: "我是哪隻寶可夢？| 有趣的寶可夢小測驗 - 隨機寶可夢生成器提供",
      description: "透過我們有趣的測驗，發現您代表哪隻寶可夢！回答幾個簡單問題，揭曉您的寶可夢分身。由隨機寶可夢生成器強力驅動。"
    },
    pokemonRandomizer: {
      title: "進階寶可夢隨機化工具 | 終極自訂寶可夢生成器",
      description: "使用我們的進階寶可夢隨機化工具釋放創造力。自訂世代、屬性等，為挑戰、Nuzlocke或純粹娛樂生成獨特的寶可夢！"
    },
    aboutUs: {
      title: "關於我們 | 隨機寶可夢生成器背後的團隊",
      description: "認識隨機寶可夢生成器的創作者。了解我們對寶可夢的熱情以及我們為全球粉絲提供最好的免費寶可夢工具的使命。"
    },
    contactUs: {
      title: "聯絡我們 | 隨機寶可夢生成器支援與回饋",
      description: "與隨機寶可夢生成器團隊取得聯繫。我們歡迎您提出問題、回饋和建議，以使我們的寶可夢工具更加完善。"
    },
    privacyPolicy: {
      title: "隱私權政策 | 隨機寶可夢生成器與工具",
      description: "查閱隨機寶可夢生成器及其相關工具的隱私權政策。了解我們如何保護您的資料並確保安全的體驗。"
    }
  },
  ja: {
    default: {
      title: "ランダムポケモンジェネレーター | 無料ポケモンランダマイザーツール",
      description: "どの地方のポケモンでもランダムに生成！ポケモンランダマイザー＆ピッカーツールを試してみよう—素早く、楽しく、次の対戦や挑戦に最適です。"
    },
    whichPokemonAmI: {
      title: "私はどのポケモン？| 楽しいポケモンクイズ - ランダムポケモンジェネレーター提供",
      description: "楽しいクイズであなたがどのポケモンかを発見しましょう！いくつかの簡単な質問に答えて、あなたのポケモンの分身を明らかにします。ランダムポケモンジェネレーター提供。"
    },
    pokemonRandomizer: {
      title: "高度なポケモンランダマイザー | 究極のカスタムポケモンジェネレーター",
      description: "当社の高度なポケモンランダマイザーで創造性を解き放ちましょう。世代、タイプなどをカスタマイズして、チャレンジ、Nuzlocke、または純粋な楽しみのためにユニークなポケモンを生成します！"
    },
    aboutUs: {
      title: "私たちについて | ランダムポケモンジェネレーターの背後にあるチーム",
      description: "ランダムポケモンジェネレーターの作成者を紹介します。ポケモンへの情熱と、世界中のファンに最高の無料ポケモンツールを提供するという私たちの使命について学びましょう。"
    },
    contactUs: {
      title: "お問い合わせ | ランダムポケモンジェネレーター サポート＆フィードバック",
      description: "ランダムポケモンジェネレーターチームにお問い合わせください。ポケモンツールをさらに良くするためのご質問、フィードバック、ご提案をお待ちしております。"
    },
    privacyPolicy: {
      title: "プライバシーポリシー | ランダムポケモンジェネレーター＆ツール",
      description: "ランダムポケモンジェネレーターおよび関連ツールのプライバシーポリシーを確認してください。データの保護方法と安全な体験の確保についてご理解ください。"
    }
  },
  ko: {
    default: {
      title: "랜덤 포켓몬 생성기 | 무료 포켓몬 랜덤라이저 도구",
      description: "모든 지방의 포켓몬을 랜덤으로 생성! 포켓몬 랜덤라이저와 선택 도구를 사용해보세요—빠르고 재미있으며, 다음 게임이나 도전에 완벽합니다."
    },
    whichPokemonAmI: {
      title: "나는 어떤 포켓몬일까? | 재미있는 포켓몬 퀴즈 - 랜덤 포켓몬 생성기 제공",
      description: "재미있는 퀴즈를 통해 당신이 어떤 포켓몬인지 알아보세요! 몇 가지 간단한 질문에 답하고 당신의 포켓몬 분신을 확인하세요. 랜덤 포켓몬 생성기가 제공합니다."
    },
    pokemonRandomizer: {
      title: "고급 포켓몬 랜덤라이저 | 궁극의 맞춤형 포켓몬 생성기",
      description: "고급 포켓몬 랜덤라이저로 창의력을 발휘하세요. 세대, 타입 등을 사용자 정의하여 챌린지, Nuzlocke 또는 순수한 재미를 위해 독특한 포켓몬을 생성하세요!"
    },
    aboutUs: {
      title: "회사 소개 | 랜덤 포켓몬 생성기 팀",
      description: "랜덤 포켓몬 생성기의 제작자를 만나보세요. 포켓몬에 대한 우리의 열정과 전 세계 팬들에게 최고의 무료 포켓몬 도구를 제공하려는 우리의 사명에 대해 알아보세요."
    },
    contactUs: {
      title: "문의하기 | 랜덤 포켓몬 생성기 지원 및 피드백",
      description: "랜덤 포켓몬 생성기 팀에 문의하세요. 포켓몬 도구를 더욱 발전시키기 위한 질문, 피드백, 제안을 환영합니다."
    },
    privacyPolicy: {
      title: "개인정보 처리방침 | 랜덤 포켓몬 생성기 및 도구",
      description: "랜덤 포켓몬 생성기 및 관련 도구의 개인정보 처리방침을 검토하십시오. 당사가 귀하의 데이터를 보호하고 안전한 경험을 보장하는 방법을 이해하십시오."
    }
  },
  es: {
    default: {
      title: "Generador Aleatorio de Pokémon | Herramienta Gratuita de Aleatorización",
      description: "¡Genera Pokémon aleatorios de cualquier región! Prueba nuestra herramienta de aleatorización y selección de Pokémon: rápida, divertida y perfecta para tu próximo juego o desafío."
    },
    whichPokemonAmI: {
      title: "¿Qué Pokémon Soy? | Divertido Test de Pokémon - Por Generador Aleatorio de Pokémon",
      description: "¡Descubre qué Pokémon eres con nuestro entretenido test! Responde unas sencillas preguntas y revela tu Pokémon equivalente. Ofrecido por el Generador Aleatorio de Pokémon."
    },
    pokemonRandomizer: {
      title: "Randomizador de Pokémon Avanzado | Generador de Pokémon Personalizado Definitivo",
      description: "¡Desata la creatividad con nuestro Randomizador de Pokémon Avanzado! Personaliza generaciones, tipos y más para generar Pokémon únicos para desafíos, Nuzlockes o pura diversión."
    },
    aboutUs: {
      title: "Sobre Nosotros | El Equipo Detrás del Generador Aleatorio de Pokémon",
      description: "Conoce a los creadores del Generador Aleatorio de Pokémon. Aprende sobre nuestra pasión por Pokémon y nuestra misión de proporcionar las mejores herramientas gratuitas de Pokémon para fans de todo el mundo."
    },
    contactUs: {
      title: "Contáctanos | Soporte y Comentarios del Generador Aleatorio de Pokémon",
      description: "Ponte en contacto con el equipo del Generador Aleatorio de Pokémon. Agradecemos tus preguntas, comentarios y sugerencias para mejorar aún más nuestras herramientas de Pokémon."
    },
    privacyPolicy: {
      title: "Política de Privacidad | Generador Aleatorio de Pokémon y Herramientas",
      description: "Revisa la Política de Privacidad del Generador Aleatorio de Pokémon y sus herramientas asociadas. Entiende cómo protegemos tus datos y garantizamos una experiencia segura."
    }
  },
  fr: {
    default: {
      title: "Générateur Aléatoire de Pokémon | Outil Gratuit de Randomisation",
      description: "Générez des Pokémon aléatoires de toutes les régions ! Essayez notre outil de randomisation et de sélection de Pokémon : rapide, amusant et parfait pour votre prochain jeu ou défi."
    },
    whichPokemonAmI: {
      title: "Quel Pokémon Suis-Je ? | Quiz Pokémon Amusant - Par Générateur Aléatoire de Pokémon",
      description: "Découvrez quel Pokémon vous êtes avec notre quiz amusant ! Répondez à quelques questions simples et révélez votre homologue Pokémon. Proposé par le Générateur Aléatoire de Pokémon."
    },
    pokemonRandomizer: {
      title: "Randomiseur de Pokémon Avancé | Générateur de Pokémon Personnalisé Ultime",
      description: "Libérez votre créativité avec notre Randomiseur de Pokémon Avancé. Personnalisez les générations, les types et plus encore pour générer des Pokémon uniques pour les défis, les Nuzlockes ou pour le pur plaisir !"
    },
    aboutUs: {
      title: "À Propos De Nous | L'Équipe Derrière le Générateur Aléatoire de Pokémon",
      description: "Rencontrez les créateurs du Générateur Aléatoire de Pokémon. Découvrez notre passion pour Pokémon et notre mission de fournir les meilleurs outils Pokémon gratuits aux fans du monde entier."
    },
    contactUs: {
      title: "Contactez-Nous | Support et Commentaires du Générateur Aléatoire de Pokémon",
      description: "Prenez contact avec l'équipe du Générateur Aléatoire de Pokémon. Vos questions, commentaires et suggestions sont les bienvenus pour améliorer encore nos outils Pokémon."
    },
    privacyPolicy: {
      title: "Politique de Confidentialité | Générateur Aléatoire de Pokémon et Outils",
      description: "Consultez la Politique de Confidentialité du Générateur Aléatoire de Pokémon et de ses outils associés. Comprenez comment nous protégeons vos données et assurons une expérience sécurisée."
    }
  },
  pt: {
    default: {
      title: "Gerador Aleatório de Pokémon | Ferramenta Gratuita de Randomização",
      description: "Gere Pokémon aleatórios de qualquer região! Experimente nossa ferramenta de randomização e seleção de Pokémon—rápida, divertida e perfeita para seu próximo jogo ou desafio."
    },
    whichPokemonAmI: {
      title: "Qual Pokémon Eu Sou? | Quiz Divertido de Pokémon - Pelo Gerador Aleatório de Pokémon",
      description: "Descubra qual Pokémon você é com nosso quiz divertido! Responda a algumas perguntas simples e revele seu Pokémon correspondente. Oferecido pelo Gerador Aleatório de Pokémon."
    },
    pokemonRandomizer: {
      title: "Randomizador de Pokémon Avançado | Gerador de Pokémon Personalizado Definitivo",
      description: "Liberte a criatividade com nosso Randomizador de Pokémon Avançado. Personalize gerações, tipos e mais para gerar Pokémon únicos para desafios, Nuzlockes ou pura diversão!"
    },
    aboutUs: {
      title: "Sobre Nós | A Equipe por Trás do Gerador Aleatório de Pokémon",
      description: "Conheça os criadores do Gerador Aleatório de Pokémon. Saiba mais sobre nossa paixão por Pokémon e nossa missão de fornecer as melhores ferramentas gratuitas de Pokémon para fãs em todo o mundo."
    },
    contactUs: {
      title: "Entre em Contato | Suporte e Feedback do Gerador Aleatório de Pokémon",
      description: "Entre em contato com a equipe do Gerador Aleatório de Pokémon. Suas perguntas, comentários e sugestões são bem-vindos para tornar nossas ferramentas Pokémon ainda melhores."
    },
    privacyPolicy: {
      title: "Política de Privacidade | Gerador Aleatório de Pokémon e Ferramentas",
      description: "Revise a Política de Privacidade do Gerador Aleatório de Pokémon e suas ferramentas associadas. Entenda como protegemos seus dados e garantimos uma experiência segura."
    }
  },
  ar: {
    default: {
      title: "مولد بوكيمون عشوائي | أداة مجانية لاختيار البوكيمون",
      description: "ولّد بوكيمون عشوائياً من أي منطقة! جرب أداة توليد واختيار البوكيمون لدينا - سريعة وممتعة ومثالية للعبتك أو تحديك القادم."
    },
    whichPokemonAmI: {
      title: "أي بوكيمون أنا؟ | اختبار بوكيمون ممتع - مقدم من مولد البوكيمون العشوائي",
      description: "اكتشف أي بوكيمون أنت مع اختبارنا الممتع! أجب عن بعض الأسئلة البسيطة واكشف عن نظيرك البوكيموني. مقدم من مولد البوكيمون العشوائي."
    },
    pokemonRandomizer: {
      title: "مولد بوكيمون عشوائي متقدم | مولد بوكيمون مخصص نهائي",
      description: "أطلق العنان للإبداع مع مولد البوكيمون العشوائي المتقدم الخاص بنا. قم بتخصيص الأجيال والأنواع والمزيد لإنشاء بوكيمونات فريدة للتحديات أو Nuzlockes أو للمتعة الخالصة!"
    },
    aboutUs: {
      title: "عنا | الفريق الذي يقف وراء مولد البوكيمون العشوائي",
      description: "تعرف على مبتكري مولد البوكيمون العشوائي. تعرف على شغفنا بالبوكيمون ومهمتنا المتمثلة في توفير أفضل أدوات بوكيمون مجانية للمعجبين في جميع أنحاء العالم."
    },
    contactUs: {
      title: "اتصل بنا | دعم مولد البوكيمون العشوائي والتعليقات",
      description: "تواصل مع فريق مولد البوكيمون العشوائي. نرحب بأسئلتك وتعليقاتك واقتراحاتك لجعل أدوات بوكيمون الخاصة بنا أفضل."
    },
    privacyPolicy: {
      title: "سياسة الخصوصية | مولد البوكيمون العشوائي والأدوات",
      description: "راجع سياسة خصوصية مولد البوكيمون العشوائي وأدواته المرتبطة. فهم كيفية حماية بياناتك وضمان تجربة آمنة."
    }
  },
  de: {
    default: {
      title: "Zufalls-Pokémon-Generator | Kostenloses Pokémon-Randomizer-Tool",
      description: "Generiere zufällige Pokémon aus jeder Region! Probiere unser Pokémon-Randomizer und Auswahlwerkzeug—schnell, unterhaltsam und perfekt für dein nächstes Spiel oder deine nächste Herausforderung."
    },
    whichPokemonAmI: {
      title: "Welches Pokémon bin ich? | Lustiges Pokémon-Quiz - Vom Zufalls-Pokémon-Generator",
      description: "Entdecke mit unserem unterhaltsamen Quiz, welches Pokémon du bist! Beantworte ein paar einfache Fragen und enthülle dein Pokémon-Gegenstück. Präsentiert vom Zufalls-Pokémon-Generator."
    },
    pokemonRandomizer: {
      title: "Fortgeschrittener Pokémon-Randomizer | Ultimativer benutzerdefinierter Pokémon-Generator",
      description: "Entfessle Kreativität mit unserem fortschrittlichen Pokémon-Randomizer. Passe Generationen, Typen und mehr an, um einzigartige Pokémon für Herausforderungen, Nuzlockes oder reinen Spaß zu generieren!"
    },
    aboutUs: {
      title: "Über uns | Das Team hinter dem Zufalls-Pokémon-Generator",
      description: "Lerne die Macher des Zufalls-Pokémon-Generators kennen. Erfahre mehr über unsere Leidenschaft für Pokémon und unsere Mission, die besten kostenlosen Pokémon-Tools für Fans weltweit bereitzustellen."
    },
    contactUs: {
      title: "Kontakt | Zufalls-Pokémon-Generator Support & Feedback",
      description: "Nimm Kontakt mit dem Team des Zufalls-Pokémon-Generators auf. Wir freuen uns über deine Fragen, dein Feedback und deine Vorschläge, um unsere Pokémon-Tools noch besser zu machen."
    },
    privacyPolicy: {
      title: "Datenschutzrichtlinie | Zufalls-Pokémon-Generator & Tools",
      description: "Lies die Datenschutzrichtlinie für den Zufalls-Pokémon-Generator und die zugehörigen Tools. Verstehe, wie wir deine Daten schützen und ein sicheres Erlebnis gewährleisten."
    }
  },
  ru: {
    default: {
      title: "Генератор Случайных Покемонов | Бесплатный Инструмент Рандомизации",
      description: "Создавайте случайных покемонов из любого региона! Попробуйте наш инструмент рандомизации и выбора покемонов—быстрый, увлекательный и идеальный для вашей следующей игры или испытания."
    },
    whichPokemonAmI: {
      title: "Какой я Покемон? | Веселая Викторина по Покемонам - от Генератора Случайных Покемонов",
      description: "Узнайте, какой вы покемон, с помощью нашей увлекательной викторины! Ответьте на несколько простых вопросов и узнайте своего покемона-двойника. Предоставлено Генератором Случайных Покемонов."
    },
    pokemonRandomizer: {
      title: "Продвинутый Рандомайзер Покемонов | Ультимативный Пользовательский Генератор Покемонов",
      description: "Раскройте творческий потенциал с нашим Продвинутым Рандомайзером Покемонов. Настраивайте поколения, типы и многое другое для создания уникальных покемонов для испытаний, Nuzlockes или просто для удовольствия!"
    },
    aboutUs: {
      title: "О нас | Команда Генератора Случайных Покемонов",
      description: "Познакомьтесь с создателями Генератора Случайных Покемонов. Узнайте о нашей страсти к покемонам и нашей миссии по предоставлению лучших бесплатных инструментов для покемонов фанатам по всему миру."
    },
    contactUs: {
      title: "Свяжитесь с нами | Поддержка и Отзывы о Генераторе Случайных Покемонов",
      description: "Свяжитесь с командой Генератора Случайных Покемонов. Мы приветствуем ваши вопросы, отзывы и предложения, чтобы сделать наши инструменты для покемонов еще лучше."
    },
    privacyPolicy: {
      title: "Политика Конфиденциальности | Генератор Случайных Покемонов и Инструменты",
      description: "Ознакомьтесь с Политикой Конфиденциальности Генератора Случайных Покемонов и связанных с ним инструментов. Узнайте, как мы защищаем ваши данные и обеспечиваем безопасный опыт."
    }
  },
  id: {
    default: {
      title: "Generator Pokémon Acak | Alat Randomizer Pokémon Gratis",
      description: "Hasilkan Pokémon acak dari region mana saja! Coba alat randomizer dan pemilih Pokémon kami—cepat, menyenangkan, dan sempurna untuk permainan atau tantangan Anda berikutnya."
    },
    whichPokemonAmI: {
      title: "Pokémon Manakah Aku? | Kuis Pokémon Seru - Oleh Generator Pokémon Acak",
      description: "Temukan Pokémon manakah dirimu dengan kuis seru kami! Jawab beberapa pertanyaan sederhana dan ungkapkan Pokémon alter egomu. Dipersembahkan oleh Generator Pokémon Acak."
    },
    pokemonRandomizer: {
      title: "Randomizer Pokémon Tingkat Lanjut | Generator Pokémon Kustom Terbaik",
      description: "Bebaskan kreativitas dengan Randomizer Pokémon Tingkat Lanjut kami. Kustomisasi generasi, tipe, dan lainnya untuk menghasilkan Pokémon unik untuk tantangan, Nuzlocke, atau kesenangan murni!"
    },
    aboutUs: {
      title: "Tentang Kami | Tim di Balik Generator Pokémon Acak",
      description: "Kenali para pembuat Generator Pokémon Acak. Pelajari tentang semangat kami terhadap Pokémon dan misi kami untuk menyediakan alat Pokémon gratis terbaik bagi para penggemar di seluruh dunia."
    },
    contactUs: {
      title: "Hubungi Kami | Dukungan & Umpan Balik Generator Pokémon Acak",
      description: "Hubungi tim Generator Pokémon Acak. Kami menyambut pertanyaan, umpan balik, dan saran Anda untuk membuat alat Pokémon kami menjadi lebih baik."
    },
    privacyPolicy: {
      title: "Kebijakan Privasi | Generator Pokémon Acak & Alat",
      description: "Tinjau Kebijakan Privasi untuk Generator Pokémon Acak dan alat terkaitnya. Pahami bagaimana kami melindungi data Anda dan memastikan pengalaman yang aman."
    }
  },
  tr: {
    default: {
      title: "Rastgele Pokémon Üreteci | Ücretsiz Pokémon Rastgele Seçim Aracı",
      description: "Herhangi bir bölgeden rastgele Pokémon üret! Pokémon rastgele seçim aracımızı dene—hızlı, eğlenceli ve bir sonraki oyunun veya meydan okuman için mükemmel."
    },
    whichPokemonAmI: {
      title: "Hangi Pokémon'um? | Eğlenceli Pokémon Testi - Rastgele Pokémon Üreteci Tarafından",
      description: "Eğlenceli testimizle hangi Pokémon olduğunuzu keşfedin! Birkaç basit soruyu yanıtlayın ve Pokémon denginizi ortaya çıkarın. Rastgele Pokémon Üreteci tarafından sunulmaktadır."
    },
    pokemonRandomizer: {
      title: "Gelişmiş Pokémon Rastgeleleştirici | Nihai Özel Pokémon Üreteci",
      description: "Gelişmiş Pokémon Rastgeleleştiricimizle yaratıcılığınızı serbest bırakın. Nesilleri, türleri ve daha fazlasını özelleştirerek meydan okumalar, Nuzlocke'lar veya saf eğlence için benzersiz Pokémon'lar üretin!"
    },
    aboutUs: {
      title: "Hakkımızda | Rastgele Pokémon Üretecinin Arkasındaki Ekip",
      description: "Rastgele Pokémon Üretecinin yaratıcılarıyla tanışın. Pokémon'a olan tutkumuz ve dünya çapındaki hayranlara en iyi ücretsiz Pokémon araçlarını sunma misyonumuz hakkında bilgi edinin."
    },
    contactUs: {
      title: "Bize Ulaşın | Rastgele Pokémon Üreteci Destek & Geri Bildirim",
      description: "Rastgele Pokémon Üreteci ekibiyle iletişime geçin. Pokémon araçlarımızı daha da iyi hale getirmek için sorularınızı, geri bildirimlerinizi ve önerilerinizi bekliyoruz."
    },
    privacyPolicy: {
      title: "Gizlilik Politikası | Rastgele Pokémon Üreteci & Araçları",
      description: "Rastgele Pokémon Üreteci ve ilgili araçların Gizlilik Politikasını inceleyin. Verilerinizi nasıl koruduğumuzu ve güvenli bir deneyim sağladığımızı anlayın."
    }
  },
  vi: {
    default: {
      title: "Trình Tạo Pokémon Ngẫu Nhiên | Công Cụ Tạo Ngẫu Nhiên Pokémon Miễn Phí",
      description: "Tạo Pokémon ngẫu nhiên từ bất kỳ vùng nào! Hãy thử công cụ tạo ngẫu nhiên và chọn Pokémon của chúng tôi—nhanh chóng, thú vị và hoàn hảo cho trận đấu hoặc thử thách tiếp theo của bạn."
    },
    whichPokemonAmI: {
      title: "Tôi Là Pokémon Nào? | Trắc Nghiệm Pokémon Vui Nhộn - Bởi Trình Tạo Pokémon Ngẫu Nhiên",
      description: "Khám phá bạn là Pokémon nào với bài trắc nghiệm vui nhộn của chúng tôi! Trả lời một vài câu hỏi đơn giản và khám phá Pokémon tương ứng của bạn. Được cung cấp bởi Trình Tạo Pokémon Ngẫu Nhiên."
    },
    pokemonRandomizer: {
      title: "Trình Tạo Ngẫu Nhiên Pokémon Nâng Cao | Trình Tạo Pokémon Tùy Chỉnh Tối Thượng",
      description: "Giải phóng sự sáng tạo với Trình Tạo Ngẫu Nhiên Pokémon Nâng Cao của chúng tôi. Tùy chỉnh thế hệ, loại và nhiều hơn nữa để tạo ra Pokémon độc đáo cho các thử thách, Nuzlocke hoặc niềm vui thuần túy!"
    },
    aboutUs: {
      title: "Về Chúng Tôi | Đội Ngũ Đằng Sau Trình Tạo Pokémon Ngẫu Nhiên",
      description: "Gặp gỡ những người tạo ra Trình Tạo Pokémon Ngẫu Nhiên. Tìm hiểu về niềm đam mê của chúng tôi đối với Pokémon và sứ mệnh của chúng tôi là cung cấp các công cụ Pokémon miễn phí tốt nhất cho người hâm mộ trên toàn thế giới."
    },
    contactUs: {
      title: "Liên Hệ | Hỗ Trợ & Phản Hồi Trình Tạo Pokémon Ngẫu Nhiên",
      description: "Liên hệ với đội ngũ Trình Tạo Pokémon Ngẫu Nhiên. Chúng tôi hoan nghênh các câu hỏi, phản hồi và đề xuất của bạn để làm cho các công cụ Pokémon của chúng tôi trở nên tốt hơn nữa."
    },
    privacyPolicy: {
      title: "Chính Sách Bảo Mật | Trình Tạo Pokémon Ngẫu Nhiên & Công Cụ",
      description: "Xem lại Chính Sách Bảo Mật cho Trình Tạo Pokémon Ngẫu Nhiên và các công cụ liên quan của nó. Hiểu cách chúng tôi bảo vệ dữ liệu của bạn và đảm bảo trải nghiệm an toàn."
    }
  },
  hi: {
    default: {
      title: "रैंडम पोकेमॉन जनरेटर | मुफ्त पोकेमॉन रैंडमाइज़र टूल",
      description: "किसी भी क्षेत्र से रैंडम पोकेमॉन जनरेट करें! हमारे पोकेमॉन रैंडमाइज़र और पिकर टूल को आज़माएं—तेज़, मज़ेदार, और आपके अगले गेम या चैलेंज के लिए एकदम सही।"
    },
    whichPokemonAmI: {
      title: "मैं कौन सा पोकेमॉन हूँ? | मजेदार पोकेमॉन क्विज़ - रैंडम पोकेमॉन जेनरेटर द्वारा",
      description: "हमारे मनोरंजक क्विज़ के साथ जानें कि आप कौन से पोकेमॉन हैं! कुछ सरल सवालों के जवाब दें और अपने पोकेमॉन समकक्ष का अनावरण करें। रैंडम पोकेमॉन जेनरेटर द्वारा संचालित।"
    },
    pokemonRandomizer: {
      title: "उन्नत पोकेमॉन रैंडमाइज़र | अंतिम कस्टम पोकेमॉन जेनरेटर",
      description: "हमारे उन्नत पोकेमॉन रैंडमाइज़र के साथ रचनात्मकता को उजागर करें। चुनौतियों, नुज़लॉक, या शुद्ध मनोरंजन के लिए अद्वितीय पोकेमॉन उत्पन्न करने के लिए पीढ़ियों, प्रकारों और बहुत कुछ को अनुकूलित करें!"
    },
    aboutUs: {
      title: "हमारे बारे में | रैंडम पोकेमॉन जेनरेटर के पीछे की टीम",
      description: "रैंडम पोकेमॉन जेनरेटर के रचनाकारों से मिलें। पोकेमॉन के प्रति हमारे जुनून और दुनिया भर के प्रशंसकों के लिए सर्वश्रेष्ठ मुफ्त पोकेमॉन उपकरण प्रदान करने के हमारे मिशन के बारे में जानें।"
    },
    contactUs: {
      title: "हमसे संपर्क करें | रैंडम पोकेमॉन जेनरेटर सहायता और प्रतिक्रिया",
      description: "रैंडम पोकेमॉन जेनरेटर टीम से संपर्क करें। हमारे पोकेमॉन टूल को और बेहतर बनाने के लिए हम आपके प्रश्नों, प्रतिक्रिया और सुझावों का स्वागत करते हैं।"
    },
    privacyPolicy: {
      title: "गोपनीयता नीति | रैंडम पोकेमॉन जेनरेटर और उपकरण",
      description: "रैंडम पोकेमॉन जेनरेटर और उससे जुड़े टूल के लिए गोपनीयता नीति की समीक्षा करें। समझें कि हम आपके डेटा की सुरक्षा कैसे करते हैं और एक सुरक्षित अनुभव सुनिश्चित करते हैं।"
    }
  }
}; 